seo:
  ogImageAlt: Tale-Logo
  home:
    title: "Tale: Projektarbeit mit deinem Team und KI-Agenten"
    description: Plane Projekte, delegiere Aufgaben an KI-Agenten und prüfe Ergebnisse im
      Team. Ein Open-Source-Arbeitsbereich mit Agenten-Sandboxes, Kontext und
      Workflows.
  pricing:
    title: Was kostet Tale? — Community & Enterprise
    description: 'Tale Enterprise: CHF 12 (EUR 14) pro User/Monat, zwei Monate
      gratis bei Jahresabrechnung. Community ist als Open Source kostenlos selbst
      gehostet.'
  contact:
    title: Kontakt zum Tale-Team — Vertrieb, Support, Demos
    description: "Sprich mit dem Tale-Team über die Zusammenarbeit mit KI-Agenten:
      Projektabläufe, Bereitstellung, Preise oder eine geführte Demo."
  about:
    title: Wer steht hinter Tale? — Über die Ruler GmbH
    description: "Ruler GmbH aus Spiez baut Tale: einen
      Open-Source-Projektarbeitsbereich, in dem Teams KI-Agenten koordinieren und
      ihre Arbeit prüfen."
  requestDemo:
    title: Tale-Demo anfragen — geführter Rundgang
    description:
      Bring eine Aufgabe aus deinem Team mit. Sieh, wie Tale Teammitglieder
      und KI-Agenten über Projektboards, Sandbox-Arbeit und Reviews
      zusammenbringt.
  hardwarePricing:
    title: Was kostet Tale-AI-Hardware? — mieten, leasen, kaufen
    description: Geräuscharme Inference-Hardware von einzelnen Nodes bis Racks —
      mieten, leasen oder kaufen. Vor Ort mit Remote-Wartung oder in sicheren
      Rechenzentren.
  platform:
    title: KI-Agenten und Projekte koordinieren | Tale
    description:
      Menschen, KI-Agenten, Aufgaben und Projektdateien in einem
      Arbeitsbereich. Tale verbindet Aufgabenboards, Agenten-Sandboxes, Wissen
      und wiederholbare Abläufe.
  platformAgents:
    title: KI-Agenten für Projektaufgaben | Tale
    description:
      Gib Projektagenten Anweisungen, Werkzeuge und eine Laufzeit wie Claude
      Code oder Codex. Weise Aufgaben zu, öffne Sandbox-Dateien und prüfe die
      Ergebnisse.
  platformChat:
    title: KI-Chat mit Quellen und Projektaufgaben | Tale
    description:
      Stelle Fragen, prüfe Quellen, vergleiche zwei Modelle in Arena und mache
      aus einem Gespräch eine Projektaufgabe für einen KI-Agenten in Tale.
  platformAutomations:
    title: Wiederholbare Workflows mit KI-Agenten | Tale
    description:
      Mache wiederkehrende Aufgaben zu Workflows mit Agentenschritten,
      Bedingungen, Konnektoren und Freigaben. Starte sie manuell, per Zeitplan
      oder Webhook.
  platformKnowledge:
    title: Gemeinsames Wissen für die Arbeit mit KI | Tale
    description: Gib der Arbeit mit KI den nötigen Kontext. Indexiere Dokumente, Websites
      und Wissenseinträge, finde zugängliche Quellen und prüfe die Belege im
      Arbeitsbereich.
  platformGovernance:
    title: KI-Governance, Genehmigungen und Nutzungslimits | Tale
    description: Konfiguriere Connector-Genehmigungen, prüfe protokollierte Aktionen und
      lege Modellbudgets und Chat-Schutzregeln für dein Team in Tale fest.
  platformProjects:
    title: Aufgabenboards für Teams und KI-Agenten | Tale
    description: Plane die Arbeit mit Teammitgliedern und KI-Agenten auf einem
      gemeinsamen Projektboard. Aufgaben, Dateien, Gespräche und Reviews
      bleiben zusammen.
  changelog:
    title: Was ist neu in Tale? — Changelog
    description: Release Notes zu jeder Tale-Version, neueste zuerst — Features,
      Fixes und inkompatible Änderungen jeder Version, veröffentlicht aus GitHub
      Releases.
notFound:
  title: Diese Seite gibt es nicht
  body: Die Adresse ist vielleicht vertippt, oder die Seite ist umgezogen. Am
    besten startest du auf der Startseite neu.
  backHome: Zur Startseite
nav:
  platform: Plattform
  resources: Ressourcen
  pricing: Preise
  openMenu: Menü öffnen
  closeMenu: Menü schließen
  homeAriaLabel: Tale Startseite
  skipToMain: Zum Hauptinhalt springen
  product:
    hub:
      label: Plattform-Übersicht
      description: So arbeiten Menschen und Agenten gemeinsam an Projekten.
    agents:
      label: Agenten
      description: Delegiere Aufgaben an Agenten mit eigenen Werkzeugen und Laufzeiten.
    chat:
      label: Chats
      description: Stelle Fragen, prüfe Quellen und übergib Aufgaben.
    projects:
      label: Projekte
      description: Plane, verteile und prüfe Aufgaben mit deinem Team.
    automations:
      label: Automatisierungen
      description: Wiederholbare Abläufe mit Auslösern und Freigaben.
    knowledge:
      label: Wissen
      description: Gemeinsamer Kontext für dein Team und deine Agenten.
    governance:
      label: Richtlinien
      description: Prüfe Aktionen und begrenze die Modellnutzung.
  resource:
    compare:
      label: Vergleiche
      description: Vergleiche Arbeitsbereiche, Workflows und Agentenlaufzeiten.
    useCases:
      label: Anwendungsfälle
      description: Konkrete Arbeit für dein Team und KI-Agenten.
    hardware:
      label: Hardware
      description: Hardware für lokale KI-Inferenz.
    docs:
      label: Dokumentation
      description: Einrichtung und Produktreferenz.
    changelog:
      label: Changelog
      description: Was neu ist, neueste zuerst.
    about:
      label: Über uns
      description: Das Schweizer Unternehmen hinter Tale.
  aboutUs: Über uns
  contactUs: Kontakt aufnehmen
  requestDemo: Demo anfragen
  getStarted: Loslegen
legal:
  downloadPdf: Drucken oder als PDF speichern
  downloadPdfAria: '{title} drucken oder als PDF speichern'
  notFound: Dieses Dokument ist nicht verfügbar.
  documentTabsAria: Dokument-Abschnitte
  tabs:
    data-processing-agreement: AVV
    technical-organizational-measures: TOM
footer:
  taleUi: Tale UI
  resources: Ressourcen
  legal: Rechtliches
  pricing: Preise
  hardwarePricing: Hardware-Preise
  contact: Kontakt
  serviceAgreement: Service-Vertrag
  hardwareAgreement: Hardware-Vertrag
  privacyPolicy: Datenschutzerklärung
  termsOfService: Nutzungsbedingungen
  processingAgreement: Auftragsverarbeitungsvertrag
  technicalOrganizationalMeasures: Technische & organisatorische Maßnahmen
  homeAriaLabel: Tale Startseite
  githubAriaLabel: GitHub
  llmsTxtLabel: llms.txt
  llmsFullTxtLabel: llms-full.txt
  platform: Platform
  company: Unternehmen
  changelog: Changelog
  features: Funktionen
address:
  country: Schweiz
home:
  hero:
    title: Dein Team und deine Agenten. Gemeinsam am Werk.
    subtitle: "Plane die Arbeit, weise Agenten Aufgaben zu und prüfe ihre Ergebnisse. Dein Team teilt Auftrag, Dateien und Gespräch."
    ctaPrimary: Demo anfragen
    ctaSecondary: Tale selbst hosten
    eyebrow: Open-Source-Arbeitsbereich für Projekte
    proof: Gemeinsame Aufgaben · Aufgaben delegieren · Parallele
      Sandbox-Arbeit · Open Source
  demos:
    hero:
      label:
        "Beispieldemo: Eine Chatfrage zu Support-Eskalationen wird mit zwei
        Quellenangaben und dem gewählten Modell beantwortet."
      prompt: Fasse die gestrigen Support-Eskalationen zusammen und entwirf ein
        Status-Update.
      routedTitle: Modell ausgewählt
      routedDetail: Auto hat Claude Sonnet für diesen Thread gewählt.
      reply1: Gestern gab es 7 Eskalationen — 5 gelöst, 2 noch offen.
      reply2: Beide offenen Fälle sind verzögerte Cargo-Bike-Lieferungen in der EU.
      reply3: Ops bestätigt, dass die Ersatzgeräte diese Woche rausgehen —
      reply4: beiden Kontakten kann also eine Lösung bis Freitag zugesagt werden.
      citation1: q3-eskalationen.pdf
      citation2: eu-liefer-runbook.pdf
      thought: 1 s überlegt
      composerModel: Claude Sonnet
      inputPlaceholder: Frag einfach…
    connect:
      label: 'Animierte Demo: Die Agentenliste zeigt Claude Code, Codex, Hermes,
        Support-Agent und OpenClaw als installierte Zeilen mit Modell-Chips.'
      windowTitle: Agenten
      searchPlaceholder: Agenten suchen
      addLabel: Agenten
      colName: Name
      colModel: Modell
      colStatus: Status
      statusReady: Bereit
      agent1: Claude Code
      agent2: Codex
      agent3: Hermes
      agent4: Support-Agent
      agent5: OpenClaw
      model1: Claude Opus
      model2: GPT-5.5
      model3: Claude Sonnet
      model4: Claude Sonnet
      model5: Claude Opus
    knowledge:
      label:
        'Animierte Demo: Die Wissens-Dokumententabelle indexiert ein PDF, eine
        Website, einen Produktkatalog und ein Runbook und zeigt
        Index-Status-Badges.'
      windowTitle: Wissen
      searchPlaceholder: Dokumente suchen
      addLabel: Wissen
      colName: Name
      colType: Typ
      colStatus: Status
      typePdf: PDF
      typeWebsite: Website
      typeCatalog: Katalog
      typeEntry: Eintrag
      statusIndexing: Indexierung…
      statusIndexed: Indexiert
      source1: q3-eskalationen.pdf
      sourceType1: pdf
      source2: hilfe.nordwind.eu
      sourceType2: website
      source3: Produktkatalog
      sourceType3: catalog
      source4: eu-liefer-runbook.pdf
      sourceType4: pdf
    automation:
      label:
        'Animierte Demo: Eine Workflow-Canvas läuft Trigger → LLM → Bedingung →
        Aktion, dann hält die Ausführungen-Tabelle den Lauf fest.'
      windowTitle: Automatisierungen
      kindTrigger: Trigger
      kindLlm: LLM
      kindCondition: Bedingung
      kindAction: Aktion
      statusCompleted: Abgeschlossen
      statusAwaiting: Wartet auf Freigabe
      statusRunning: Läuft
      trigger: Neue Email
      llm: Intent klassifizieren
      condition: Rückerstattung?
      branchYes: Ja
      action: Antwort entwerfen
      actionAlt: An Sales weiterleiten
      logTitle: Ausführungen
      logColRun: Lauf
      logColStatus: Status
      logColDuration: Dauer
      run1: '#482'
      runTone1: done
      duration1: 3,2s
      run2: '#483'
      runTone2: pending
      duration2: —
      run3: '#484'
      runTone3: running
      duration3: 1,1s
    govern:
      label: "Beispieldemo: Eine schreibende Konnektor-Aktion einer Automatisierung
        wartet auf Freigabe und hält danach Entscheidung und Ergebnis fest."
      approvalTitle: 42 Rückerstattungs-Emails an betroffene Kontakte senden?
      requester: Inbox-Triage · Antwort entwerfen
      approve: Freigeben
      reject: Ablehnen
      approved: Freigegeben
      auditTitle: Lauf-Journal
      audit1: Freigegeben von anna@nordwind.eu
      audit2: 42 Emails über Gmail eingereiht
      audit3: Entscheidung im Audit-Log erfasst
      budgetLabel: Monatsbudget
      budgetValue: CHF 412 / 1'000
    arena:
      label:
        'Animierte Demo: Chat Arena stellt eine Anfrage zwei Modellen gegenüber —
        Claude Sonnet und GPT-5.5 nebeneinander.'
      prompt: Entwirf eine Kontaktantwort zur verzögerten EU-Lieferung.
      modelA: Claude Sonnet
      modelB: GPT-5.5
      vs: vs
      replyA1:
        Entschuldige die Verzögerung und bestätige, dass Ersatzgeräte diese
        Woche rausgehen.
      replyA2:
        Sage Freitag als Lösungstermin zu und sende den Tracking-Link, sobald
        Ops ihn postet.
      replyA3: Schließe mit dem Link zur Eskalations-Richtlinie, den der Kontakt
        intern teilen kann.
      replyB1:
        Bestätige die Verzögerung, zitiere die Eskalations-Richtlinie und setze
        Freitag als Zusage.
      replyB2: Hänge eine kurze Next-Step-Checkliste an, die der Kontakt intern
        weiterleiten kann.
      replyB3:
        Biete ein Rückruf-Fenster an, falls der Tracking-Link bis Donnerstag
        fehlt.
    projects:
      label:
        'Animierte Demo: Die Projekte-Liste zeigt abgegrenzte Workspaces mit
        Agent-Anzahl und Mitgliedern.'
      windowTitle: Projekte
      searchPlaceholder: Projekte suchen
      newProject: Neues Projekt
      colName: Name
      colAgents: Agenten
      colMembers: Mitglieder
      project1: Customer Support
      project2: Engineering
      project3: Vertriebs-Recherche
      project4: Ops & Logistik
      agents1: 3 Agenten
      agents2: 5 Agenten
      agents3: 2 Agenten
      agents4: 4 Agenten
      members1: '8'
      members2: '14'
      members3: '5'
      members4: '11'
    tasks:
      windowTitle: "Aufgaben"
      colTodo: "Zu erledigen"
      colInProgress: "In Bearbeitung"
      colInReview: "In Prüfung"
      colDone: "Erledigt"
      working: Arbeitet
      id1: TEAM-14
      id2: TEAM-15
      id3: TEAM-12
      id4: TEAM-11
      id5: TEAM-9
      label: "Animierte Demo: Ein gemeinsames Projektboard mit Zu erledigen, In Bearbeitung, In Prüfung und Erledigt. Personen und Agenten übernehmen Aufgaben; ein Agent bearbeitet eine Karte."
      title1: Kampagnenbriefing planen
      assignee1: Nicht zugewiesen
      title2: Kundenfeedback prüfen
      assignee2: Mira
      title3: Kundenportal bauen
      assignee3: Entwickler-Agent
      title4: Recherchebericht prüfen
      assignee4: Mira
      title5: Team-Handbuch aktualisieren
      assignee5: Doku-Agent
    sandbox:
      filesTab: Files
      liveTab: Live
      treeRoot: workspace
      liveHint: Live-Browseransicht
      label: 'Animierte Demo: Ein Agent erstellt eine Webseite, zeigt ihren
        HTML-Code im Bereich Files und öffnet sie dann in der
        Live-Browseransicht.'
      prompt: Baue eine kleine Projektseite und öffne sie im Browser, damit ich
        sie prüfen kann.
      agent: Claude Code
      model: Claude Opus
      reply:
        index.html und eine lokale Vorschau sind erstellt. Prüfe den Quelltext
        unter Files und die Seite unter Live.
      file1: index.html
      file2: styles.css
      file3: tests/preview.spec.ts
      file4: README.md
      activeFile: index.html
      code1: "<main><h1>Northwind</h1><p>Kundenportal</p>"
      code2: "<section><h2>Auftrag</h2><p>Umfang und Ziele</p></section>"
      code3: "<section><h2>Dateien</h2><p>Quellcode und Tests</p></section>"
      code4: "<section><h2>Prüfung</h2><p>Bereit für Feedback</p></section></main>"
      browserUrl: http://127.0.0.1:5173
      browserTitle: Projektvorschau · localhost
      previewTitle: "Northwind"
      previewDescription: "Kundenportal"
      previewItem1: "Auftrag"
      previewDetail1: "Umfang und Ziele"
      previewItem2: "Dateien"
      previewDetail2: "Quellcode und Tests"
      previewItem3: "Prüfung"
      previewDetail3: "Bereit für Feedback"
  tour:
    title: Von der gemeinsamen Aufgabe zum geprüften Ergebnis
    subtitle: Weise Aufgaben zu, gib Agenten den nötigen Kontext und arbeite mit
      deinem Team am nächsten Schritt.
    connect:
      eyebrow: Agents & Connectors
      title: "Delegiere Arbeit an deine Agenten"
      description: "Gib Agenten ihre Anweisungen und Werkzeuge. Verfolge die Arbeit in persistenten Sandboxes und prüfe die gelieferten Dateien."
    pool:
      eyebrow: Wissen
      title: "Gib der Arbeit den nötigen Kontext"
      description: "Verbinde Projektdateien und gemeinsames Wissen. Prüfe die Quellen, die Agenten verwenden."
    delegate:
      eyebrow: Automatisierungen
      title: "Wiederhole bewährte Abläufe"
      description: "Verbinde Agentenschritte, Bedingungen und Aktionen. Prüfe jeden Lauf."
    govern:
      eyebrow: Freigaben & Audit
      title: "Prüfe und genehmige"
      description: "Prüfe Ergebnisse, genehmige konfigurierte Aktionen und verfolge den Audit-Verlauf."
    arena:
      eyebrow: Chat Arena
      title: "Vergleiche Modellantworten"
      description: "Stelle zwei Modellen dieselbe Frage in Arena. Wähle die passende Antwort."
    projects:
      eyebrow: Projekte
      title: |-
        Plane die Arbeit
        mit deinem Team
      description: Bündle Teammitglieder, Aufgaben, Dateien und Gespräche in einem
        Projekt. Weise die Arbeit einer Person oder einem Agenten zu und
        verfolge den Fortschritt auf dem Board.
    explore: '{module} entdecken'
  tagline:
    eyebrow: Dein Arbeitsbereich, deine Entscheidung
    title: Deine Infrastruktur. Deine Daten. Deine Regeln.
    subtitle: Wähle, wo dein Arbeitsbereich läuft und welche Modelle deine Agenten
      nutzen.
    pillars:
      selfHosted:
        title: Standardmäßig selbst gehostet
        description:
          Betreibe Tale auf eigener Infrastruktur oder nutze Managed Hosting.
          Lokale Modelle halten die Inferenz lokal; externe Anbieter,
          Konnektoren und Werkzeuge nutzen die von dir eingerichteten
          Verbindungen.
      security:
        title: Eingebaute Sicherheit
        description: Verwalte Mitglieder, Rollen, Single Sign-on, Budgets und
          konfigurierte Schutzregeln im selben Produkt. Nutze Audit-Einträge
          und den Ausführungsverlauf, um Vorgänge nachzuvollziehen.
      openSource:
        title: Vollständig Open Source
        description:
          Der gesamte Code ist öffentlich und Open Source. Lies ihn,
          auditier ihn, ändere, was du brauchst — ohne jemanden zu fragen.
  connectors:
    title: Angedockt an die Tools, die du schon nutzt
    subtitle: Verbinde die Dienste, die deine Projekte brauchen. Richte Zugangsdaten
      ein und gib Agenten und Workflows den nötigen Zugriff für ihre Aufgaben.
  agents:
    title: Deine Agenten, deine Wahl
    subtitle: Nutze deine bevorzugte Laufzeit mit deinem eigenen Abo oder per API abgerechneten Modellen.
  faq:
    eyebrow: FAQ
    title: Häufig gestellte Fragen
    stillQuestions: Noch Fragen?
    contactTeam: Team kontaktieren
    whatIsTale:
      q: Was ist Tale?
      a: Tale ist ein Open-Source-Projektarbeitsbereich für Teams und
        KI-Agenten. Plane Aufgaben mit deinem Team, delegiere Arbeit an
        Agenten und prüfe die Ergebnisse am selben Ort. Tale verbindet
        Aufgabenboards, Agenten-Sandboxes, gemeinsames Wissen und Workflows.
        Bei Bedarf kannst du es selbst hosten und private Modelle nutzen.
    openSource:
      q: Ist Tale Open Source?
      a:
        Ja. Tale ist Open Source, und der volle Funktionsumfang steckt in der
        kostenlosen Community-Edition — Enterprise ergänzt Support und Services,
        keine Funktionen.
    onPrem:
      q: Läuft Tale komplett on-premises oder air-gapped?
      a: Tale kann auf deiner Infrastruktur mit lokalen Modellen laufen. Für
        einen Offline-Betrieb brauchst du auch lokale Abhängigkeiten und
        begrenzte ausgehende Verbindungen. Aktivierte Cloud-Modelle, externe
        Werkzeuge und Konnektoren können Daten nach außen senden;
        Selbsthosting macht sie nicht automatisch lokal.
    enterprisePricing:
      q: Wie funktioniert die Enterprise-Preisgestaltung?
      a:
        Enterprise wird pro Nutzer und Monat abgerechnet, mit zwei Monaten gratis bei
        jährlicher Zahlung. Speicher über das enthaltene Kontingent hinaus wird
        pro TB/Monat berechnet. Die Community-Edition bleibt für den selbst
        gehosteten Einsatz kostenlos.

    byoModels:
      q: Muss ich eigene KI-Modelle mitbringen?
      a: Nein. Du kannst eigene Modelle mitbringen, musst es aber nicht. Tale
        unterstützt die meisten großen KI-Anbieter ohne Aufschlag —
        Cloud-Modellnutzung wird zu den Tarifen deines Anbieters abgerechnet und
        ist nicht in den Plänen enthalten.




    whoFor:
      q: Für wen ist Tale gedacht?
      a: Tale ist für Teams, die Arbeit für KI-Agenten organisieren und mit
        ihnen zusammenarbeiten wollen. Technische Teammitglieder richten
        Agenten, Werkzeuge und Repository-Zugriffe ein; andere beschreiben
        Aufgaben, besprechen den Fortschritt und prüfen Ergebnisse. Nutze Tale
        für Softwareprojekte, Marketingkampagnen, Recherchen, Berichte oder
        wiederkehrende Betriebsaufgaben. Was ein Agent tun kann, hängt von
        seinen Werkzeugen und Berechtigungen ab.
    agentSubscriptions:
      q: Kann ich mein bestehendes Agentenabo nutzen?
      a: Ja, wenn die Laufzeit dieses Abo unterstützt. Hinterlege dein eigenes
        Token oder unterstützte Anmeldedaten und wähle die passende Laufzeit.
        Du kannst auch Modelle per API nutzen. Abo-Aufrufe unterliegen den
        Grenzen des Anbieters und umgehen Tales Gateway-Messung und
        Ausgabenlimits. Prüfe diese Nutzung beim Anbieter.
  cta:
    title: Bring dein nächstes Projekt zu Tale
    description: Starte einen selbst gehosteten Arbeitsbereich oder bring eine echte
      Aufgabe zur Demo mit. Sieh, wie dein Team und KI-Agenten sie gemeinsam
      bearbeiten können.
    primary: Demo anfragen
    getStarted: Loslegen
    terminalTitle: Selbst hosten in vier Befehlen
    copy: Kopieren
    copied: Kopiert
    docsLink: Vollständige Installationsanleitung
complianceTrust:
  certifications:
    iso27001: Ruler GmbH · ISO 27001
    mit: Open Source
    openSource: Open Source
pricing:
  title: Was kostet Tale?
  description: Tale Enterprise kostet CHF 12 (EUR 14) pro User/Monat, bei
    Jahresabrechnung zwei Monate gratis. Die Open-Source-Community-Edition
    ist kostenlos selbst gehostet.
  note: Alle Produkt-Features sind in Community und Enterprise enthalten.
    Zusätzliche Cloud-KI-Modellnutzung wird zu den Preisen deines Anbieters
    abgerechnet.
  popular: Beliebt
  planIncludes: 'Im Plan enthalten:'
  billing:
    ariaLabel: Abrechnungszeitraum
    monthly: Monatlich
    yearly: Jährlich (2 Monate gratis)
  billingNote:
    monthly: Monatlich abgerechnet
    yearly: Jährlich abgerechnet · 2 Monate gratis
  users:
    label: Anzahl der Nutzer
    minTooltip: Mindestens 25 Nutzer
  region:
    ariaLabel: Währung
    CH: CHF
    DE: EUR
  community:
    deployment: Nur selbst gehostet
    price: Kostenlos
    priceSuffix: ''
    tagline:
      Jedes Produkt-Feature, kostenlos selbst gehostet — Support läuft über
      GitHub.
    cta: Loslegen
    feature1: Selbst gehostet
    feature2: Open Source
    feature3: Community-gepflegt (GitHub)
    feature4: Community-Support (GitHub)
  enterprise:
    deployment: Cloud oder selbst gehostet
    priceSuffix: /Monat + MwSt.
    storageAddOn: 1 TB + {price}/TB/Monat zusätzlicher Speicher
    userBreakdown: '{count} Nutzer × {perUser}/Nutzer/Monat'
    tagline:
      Alles aus Community, professionell betrieben — Installation, Wartung
      und Support, in der Cloud oder auf deiner Hardware.
    cta: Kontakt aufnehmen
    feature1: Selbst gehostet oder Cloud
    feature2: Professioneller Betrieb durch die ISO-27001-zertifizierte Ruler GmbH
    feature3: Vertrag zur Auftragsverarbeitung (AVV)
    feature4: E-Mail-, Telefon- und Remote-Support
    feature5: Installation und laufende Wartung
    feature7: Einfluss auf die Produkt-Roadmap
  compare:
    title: Pläne vergleichen
    subtitle: Übersicht über jeden Plan
    categories:
      deployment: Bereitstellung
      compliance: Compliance
      support: Support
      installation: Standardinstallation
      maintenance: Wartung
      customDevelopment: Individuelle Entwicklung
      consulting: Beratung
      roadmap: Einfluss auf die Produkt-Roadmap
    values:
      installationFee:
        CH: CHF 1.990
        DE: EUR 2.290
      hourlyRate:
        CH: CHF 180 / Std.
        DE: EUR 200–260 / Std.
    sections:
      services: Professionelle Dienstleistungen
      other: Sonstiges
    rows:
      selfHosted: Selbst gehostet
      cloud: Cloud
      localDataCenters: Lokale Rechenzentren (CH & EU)
      dpa: Vertrag zur Auftragsverarbeitung (AVV)
      iso: ISO-27001-zertifizierter Betrieb
      piiRedaction: PII-Schwärzung
      customDpa: Individueller AVV
      customDpaInfo:
        Wir akzeptieren auch individuelle Auftragsverarbeitungsverträge
        mit unseren Kunden.
      emailSupport: E-Mail-Support
      emailSupportInfo: 'Antworten innerhalb Geschäftszeiten: Mo–Fr, 08:00–17:00 (MEZ/MESZ).'
      phoneSupport: Telefon-Support
      phoneSupportInfo: 'Verfügbar innerhalb Geschäftszeiten: Mo–Fr, 08:00–17:00 (MEZ/MESZ).'
      remoteSupport: Remote-Support
      remoteSupportInfo: 'Verfügbar innerhalb Geschäftszeiten: Mo–Fr, 08:00–17:00 (MEZ/MESZ).'
    cellLabels:
      yes: Enthalten
      no: Nicht enthalten
  extras:
    hardware:
      title: Hardware
      prefix: Für Self-Hosting bieten wir
      linkLabel: flexible Hardware-Optionen
      suffix: ' — Miete, Kauf oder Finanzierung.'
    cloudProviders:
      title: Cloud-KI-Anbieter
      description: Wir unterstützen OpenAI, Anthropic, Gemini und weitere große
        Cloud-KI-Anbieter in CH & EU — ohne Aufschlag; die Nutzung wird zu
        Anbieterpreisen abgerechnet.
  terms:
    title: Bedingungen
    prefix: Alle Konfigurationen unterliegen unserem
    linkLabel: Servicevertrag
    suffix: .
hardwarePricing:
  title: Was kostet Tale-AI-Hardware?
  description: Geräuscharme Inference-Hardware von einzelnen Nodes bis Racks —
    mieten, leasen oder kaufen. Vor Ort mit Remote-Wartung oder in sicheren
    Rechenzentren.
  popular: Beliebt
  configIncludes: 'Konfiguration enthält:'
  billing:
    ariaLabel: Zahlungsoption
    leasing: Leasing
    buying: Kauf
    termAriaLabel: Leasinglaufzeit
    termHeading: 'Monate:'
  modesAriaLabel: Bereitstellungsmodus
  deploymentNote: Alle Hardware-Konfigurationen sind geräuschlos und können bei
    dir vor Ort installiert und remote von unserem Team gewartet werden — oder
    in unseren sicheren Rechenzentren gehostet werden.
  tiers:
    quality:
      priceSuffix: + MwSt./Monat
      buySuffix: + MwSt.
      tagline: Abgestimmt auf Genauigkeit und konsistente Ergebnisse.
      nodeTagline: Gebaut für Genauigkeit und konsistente Ergebnisse.
      cta: Kontakt aufnehmen
      highlightQuality: Qualität
      highlightSpeed: Standard
    hybrid:
      priceSuffix: + MwSt./Monat
      buySuffix: + MwSt.
      tagline: Balanciert Genauigkeit und Tempo.
      nodeTagline: Verbindet lokale Datenkontrolle mit schneller Inferenz.
      cta: Kontakt aufnehmen
      highlightQuality: Hoch
      highlightSpeed: Hoch
    speed:
      priceSuffix: + MwSt./Monat
      buySuffix: + MwSt.
      tagline: Abgestimmt auf Antworten mit niedriger Latenz.
      nodeTagline: Gebaut für Antworten mit niedriger Latenz.
      cta: Kontakt aufnehmen
      highlightQuality: Standard
      highlightSpeed: Qualität
    rack:
      priceSuffix: + MwSt./Monat
      buySuffix: + MwSt.
      tagline: Multi-Node-Leistung in einem einzigen, sicheren Gehäuse — mit
        Confidential Computing.
      nodeTagline: Multi-Node-Leistung in einem einzigen, sicheren Gehäuse — mit
        Confidential Computing.
      cta: Kontakt aufnehmen
      highlightQuality: Hoch
      highlightSpeed: Hoch
  compare:
    title: Konfigurationen vergleichen
    subtitle: Übersicht über jede Konfiguration
    categories:
      model: Empfohlenes KI-Modell
      modelInfo:
        Vorschlag für ein Multi-Node-Setup. Einzelne Nodes können kleinere
        Varianten ausführen — das tatsächliche Modell wählt dein Team bei der
        Inbetriebnahme.
      size: Größe
      sizeInfo: Richtwerte — die tatsächliche Größe kann leicht abweichen.
      gpu: Chip (GPU)
      cpu: Chip (CPU)
      ram: KI-RAM
      ramInfo:
        Schneller Speicher für KI-Berechnungen, z. B. GDDR7-Videospeicher oder
        Unified Memory (UMA).
      umaInfo:
        Unified Memory Architecture — RAM, der sich CPU und GPU auf demselben
        Chip teilen (Apple Silicon).
      gddr7Info:
        Graphics DDR der 7. Generation — Videospeicher mit hoher Bandbreite
        auf der GPU-Karte, optimiert für KI-Inferenz.
      ddr5Info: DDR-SDRAM der fünften Generation (schneller und effizienter als DDR4).
      ddr5eccInfo: DDR5 mit Fehlerkorrekturcode — Server-Speicher, der
        Einzelbit-Fehler erkennt und korrigiert.
      zen4Info: AMDs x86-CPU-Mikroarchitektur der 4. Generation (2022).
      zen5Info: AMDs x86-CPU-Mikroarchitektur der 5. Generation (2024).
      int4Info:
        4-Bit-Integer-Quantisierung — minimaler Präzisionsverlust, ~4× weniger
        Speicherbedarf.
      m2nvmeInfo: m.2-NVMe-SSDs in einem ZFS-RAID-Pool — schneller, redundanter Speicher.
      nqInfo: Quality-Node
      naInfo: Application-Node
      nsInfo: Speed-Node
      mqInfo: Multi-Node Quality
      mhInfo: Multi-Node Hybrid
      msInfo: Multi-Node Speed
      srInfo: Server Rack
      systemRam: RAM
      ssd: SSD
      hdd: HDD
      cables: Kabel & Netzwerkausrüstung
      confidentialComputing: Confidential Computing
      version: Produktversion
      productNumber: Produktnummer
      composition: Zusammensetzung
    cellLabels:
      yes: Enthalten
      onRequest: Auf Anfrage verfügbar
      notAvailable: Nicht verfügbar
    sections:
      specifications: Spezifikationen
      other: Sonstiges
  extras:
    software:
      title: Software & Services
      prefix: Für Installation, Support und Professional Services bieten wir
      linkLabel: flexible Optionen
      suffix: .
  terms:
    title: Bedingungen
    prefix: Alle Konfigurationen unterliegen unserem
    linkLabel: Hardware-Vertrag
    suffix: .
  warranty:
    title: Garantie
    content: 24 Monate Hersteller-Garantie (auf Anfrage erweiterbar auf 36 Monate)
  metrics:
    quality: Ausgabequalität
    speed: Token-Geschwindigkeit
    storage: Datenspeicher
requestDemo:
  eyebrow: Demo
  title: Sieh dir Tale live an
  paragraph1: 'Eine geführte Demo ist das Produkt live, keine Folien: Agents
    angedockt, Antworten in deiner Art von Wissen verankert, eine Automatisierung,
    die auf Freigabe wartet — auf einer selbst gehosteten Instanz.'
  paragraph2: Erzähl uns, was dein Team heute nutzt und was dein Netzwerk nie
    verlassen darf. Innerhalb eines Arbeitstags melden wir uns mit Termin und
    einem Plan, der passt.
  fieldName: Name
  fieldPhone: Telefon
  fieldCompany: Unternehmen
  fieldInterests: Interessiert an
  fieldMessage: Zusätzlicher Kommentar
  placeholderName: Vollständigen Namen eingeben
  placeholderEmail: E-Mail-Adresse eingeben
  placeholderPhone: Telefonnummer eingeben
  placeholderCompany: Firmennamen eingeben
  placeholderMessage: Beschreib dein Projekt. Alle geteilten Projektdetails
    behandeln wir vertraulich.
  interests:
    enterprise: Enterprise-Lösungen
    professionalServices: Professional Services
    customAiTraining: Individuelles KI-Modelltraining
    aiHardware: KI-Hardware
  submit: Kontakt aufnehmen
contact:
  eyebrow: Kontakt
  title: Kontakt aufnehmen
  description: Besprich ein Projekt, das dein Team an KI-Agenten delegieren möchte, oder
    stelle Fragen zu Bereitstellung, Enterprise und Support. Erzähl uns, wie
    dein Team heute arbeitet.
  fieldName: Name
  fieldCompany: Unternehmen
  fieldMessage: Nachricht
  placeholderName: Vollständigen Namen eingeben
  placeholderEmail: E-Mail-Adresse eingeben
  placeholderCompany: Firmennamen eingeben
  placeholderMessage:
    Teil uns ein paar Details mit, damit wir deine Anforderungen
    besser verstehen. Alle geteilten Projektdetails behandeln wir vertraulich.
  submit: Kontakt aufnehmen
forms:
  email: E-Mail
  honeypotLabel: Website
  privacyPrefix: Ich bestätige, dass ich die
  privacyLink: Datenschutzerklärung gelesen habe
  privacyRequired: Bestätige, dass du die Datenschutzerklärung gelesen hast.
  validation:
    nameRequired: Gib deinen Namen ein.
    nameTooLong: Dein Name darf höchstens 2.000 Zeichen enthalten.
    emailRequired: Gib deine E-Mail-Adresse ein.
    emailInvalid: Gib eine gültige E-Mail-Adresse ein.
    emailTooLong: Die E-Mail-Adresse darf höchstens 2.000 Zeichen enthalten.
    companyTooLong: Der Firmenname darf höchstens 2.000 Zeichen enthalten.
    messageRequired: Gib deine Nachricht ein.
    messageTooShort: Erzähl uns etwas mehr. Verwende mindestens 10 Zeichen.
    messageTooLong: Deine Nachricht darf höchstens 2.000 Zeichen enthalten.
    phoneInvalid: Verwende für die Telefonnummer Ziffern, Leerzeichen, +, - oder Klammern.
    phoneTooShort: Gib eine Telefonnummer mit mindestens 4 Ziffern ein.
    phoneTooLong: Die Telefonnummer darf höchstens 32 Zeichen enthalten.
    invalid: Prüfe diese Eingabe und versuche es erneut.
  errors:
    generic: Etwas ist schiefgelaufen. Versuch es erneut.
    rateLimited: Zu viele Anfragen. Warte einen Moment, dann versuch es erneut.
    notConfigured:
      Diese Installation hat noch keinen Formularversand eingerichtet —
      deine Nachricht wurde nicht gesendet. Erreich das Team bitte über einen
      anderen Kanal.
    serverUnavailable:
      Deine Nachricht konnte gerade nicht gesendet werden. Versuch
      es in ein paar Minuten erneut.
    tooFast: Moment — prüf deine Angaben, bevor du absendest.
  success:
    title: Danke — wir haben es erhalten
    description: Wir melden uns innerhalb eines Werktags.
    sendAnother: Weitere Nachricht senden
about:
  hero:
    eyebrow: Über uns
    title: Wer steht hinter Tale?
    description: Ruler GmbH aus Spiez in der Schweiz entwickelt Tale. Wir bauen einen
      Open-Source-Projektarbeitsbereich, in dem Menschen und KI-Agenten
      gemeinsam Probleme lösen. Unsere ISO-27001-Zertifizierung umfasst Tale
      Enterprise und professionelle Dienstleistungen.
    ctaContact: Kontakt aufnehmen
    ctaGithub: Code ansehen
  facts:
    founded:
      label: Gegründet
      value: '2020'
    location:
      label: Sitz
      value: Spiez, Schweiz
    certified:
      label: Zertifiziert
      value: Ruler GmbH · ISO 27001
    license:
      label: Lizenz
      value: Open Source
  story:
    heading: Unsere Geschichte
    p1: Die Ruler GmbH wurde 2020 von Yannick Monney in Spiez im Kanton Bern
      gegründet. Von Anfang an in der Schweiz ansässig und herstellerneutral —
      ohne Bindung an einen Cloud- oder Modellanbieter.
    p2: Wir bauen Tale für Unternehmen, in denen KI-Agenten mit den Teams
      zusammenarbeiten sollen. Arbeit braucht Zuständigkeiten, Kontext,
      Abstimmung und einen Ort, an dem Ergebnisse geprüft werden. Ein
      gemeinsamer Projektarbeitsbereich bringt das zusammen.
    tagline: Deine Infrastruktur. Deine Daten. Deine Regeln.
    p3: Tale verbindet Projektboards, Agenten-Sandboxes, Dateien, Wissen und
      Workflows in einem Produkt. Teams können Aufgaben zuweisen, den
      Fortschritt verfolgen und Ergebnisse gemeinsam prüfen. Laufzeiten,
      Modelle und Betriebsform bleiben wählbar.
  product:
    heading: Was wir bauen
    description: "Tale ist ein Open-Source-Arbeitsbereich für Teams und KI-Agenten: ein
      Ort, um Projekte zu planen, Aufgaben zu delegieren und Ergebnisse zu
      prüfen."
    orchestrator:
      title: Menschen und Agenten im selben Projekt
      body: Weise Arbeit Teammitgliedern oder Projektagenten zu. Gib den Agenten
        Anweisungen, Werkzeuge und eine unterstützte Laufzeit. Verfolge ihre
        Aufgaben und prüfe die Ergebnisse.
    openSource:
      title: Open Source, ohne Sternchen
      body: Der gesamte Code ist öffentlich auf GitHub und Open Source. Die
        kostenlose Community-Edition hat denselben Funktionsumfang; Enterprise
        ergänzt Support und Services für CHF 12 (EUR 14) pro User/Monat.
    deployment:
      title: Deine Infrastruktur oder unsere
      body: Hoste Tale auf eigener Infrastruktur oder nutze Managed Hosting in der
        Schweiz oder der EU. Wähle lokale oder Cloud-Modelle und lege fest,
        welche externen Dienste der Arbeitsbereich erreichen darf.
    beyond:
      title: Mehr als Software
      body: Wir liefern KI-Hardware zum Mieten, Leasen oder Kaufen für Teams, die Modelle auf ihrer eigenen Infrastruktur betreiben.
  work:
    heading: Wie wir mit Unternehmen arbeiten
    description: Damit Agenten sinnvoll mitarbeiten, braucht es neben Software einen
      klaren Ablauf. Wir helfen Teams, ihre Quellen vorzubereiten, passende
      Aufgaben zu definieren und die Ergebnisprüfung festzulegen.
    dataQuality:
      title: Daten, auf die man Agents ansetzen kann
      body: Wir helfen dabei, Quellen, Zuständigkeiten und Herkunft zu
        strukturieren, damit Menschen und Agenten relevante Belege finden und
        prüfen können.
    regulated:
      title: Zu Hause in regulierten Umgebungen
      body: Wir helfen Teams, Anforderungen an Betrieb, Zugriff und Prüfung
        einzuordnen. Die ISO-27001-Zertifizierung der Ruler GmbH umfasst Tale
        Enterprise und professionelle Dienstleistungen. Fordere die für deine
        Organisation passenden Nachweise und den Geltungsbereich an.
    edge:
      title: Ein Vorsprung, der dir bleibt
      body: Behalte Projektkontext, Workflows und Review-Verlauf deines Teams
        zusammen, wenn weitere Agenten hinzukommen. Der Open-Source-Code
        sowie die Wahl von Laufzeiten und Betriebsform lassen dich Tale an die
        Arbeit deines Unternehmens anpassen.
    tailored:
      title: Lösungen, die zu deinen Zielen passen
      body: Keine zwei Organisationen führen KI gleich ein. Wir bauen Agents,
        Automatisierungen, Wissen und Hardware um das herum, was du erreichen willst
        — und lassen weg, was du nicht brauchst.
  values:
    heading: Wofür wir stehen
    privacy:
      title: Deine Daten bleiben deine
      body: Behalte die Wahl über Betrieb und Modelle. Nutze bei Bedarf lokale
        Inferenz und prüfe die Datenflüsse der externen Dienste, die du
        verbindest.
    neutrality:
      title: Unabhängig & herstellerneutral
      body: In der Schweiz ansässig und herstellerneutral — ohne Bindung an
        einen Cloud- oder Modellanbieter, damit dein Deployment nur dir
        verpflichtet ist.
    transparency:
      title: Transparent von Grund auf
      body: Eine öffentliche Open-Source-Codebasis und ein Unternehmen,
        das du im Schweizer Handelsregister nachschlagen kannst. Was wir
        ausliefern, kannst du lesen.
    control:
      title: Menschen behalten die Kontrolle
      body: Menschen definieren die Arbeit, vergeben Agentenzugriffe und legen
        Review- und Freigaberegeln fest. Teams können Ergebnisse und
        Ausführungsverlauf prüfen, bevor sie den nächsten Schritt entscheiden.
  cta:
    title: Sprich mit dem Team
    description: Fragen zu Tale, zum Deployment oder zur Zusammenarbeit mit der
      Ruler GmbH? Buch eine Demo oder schreib uns über das Kontaktformular.
featureShared:
  ctaPrimary: Demo anfragen
  ctaSecondary: Kontakt
  ctaGetStarted: Loslegen
  ctaTitle: Sieh den nächsten Ablauf deines Teams in Tale
  ctaDescription: Bring eine Aufgabe zur Demo mit oder starte einen Arbeitsbereich und
    probiere sie mit deinen Agenten aus.
  relatedHeading: Verwandte Module
  docsHeading: Docs lesen
platformAgents:
  eyebrow: Agenten
  title: Was sind Agents in Tale?
  description: Projektagenten bearbeiten Aufgaben gemeinsam mit deinem Team. Gib jedem
    Agenten Anweisungen, eine unterstützte Laufzeit, ein Modell und Tools.
    Verfolge die Arbeit in der Sandbox und prüfe Berichte und Dateien.
  capabilities:
    heading: Was können Agents?
    description:
      Richte wiederverwendbare Agenten für Projektaufgaben ein – von Recherche
      und Dokumenten bis zu Code-Änderungen und Reviews.
    items:
      - title: Klare Aufgabe und Laufzeit
        body:
          Wähle eine Laufzeit, ein kompatibles Modell mit Anbieter, dauerhafte
          Anweisungen und die nötige Ausstattung.
        docsLabel: Agent-Konzepte
      - title: Unterstützte Agent-Laufzeiten
        body:
          Binde Claude Code, Codex, Hermes und OpenClaw als Agent-Laufzeit, auf der ein
          Projekt-Agent oder ein Automatisierungs-Agent-Knoten läuft.
        docsLabel: Agent-Laufzeiten
      - title: Delegation zwischen Agents
        body:
          Ein entsprechend ausgestatteter Manager-Agent kann andere Agenten
          für startbereite Aufgaben desselben Projekts starten. Dabei gelten
          Delegations-, Zugriffs- und Kapazitätsgrenzen.
        docsLabel: Aufgaben-Automatisierung
      - title: Skills als wiederverwendbare Bundles
        body:
          Gib Agenten wiederverwendbare Anweisungen und Hilfsdateien als
          Skills. Statte sie etwa für die Dokumentenerstellung oder das Prüfen
          von Änderungen aus.
        docsLabel: Projekt-Agenten
      - title: Tools für den Projektkontext
        body:
          Erteile die Plattform-Tools, mit denen der Agent Aufgaben findet,
          Dateien liest und Wissen abruft. Für die Quellen gelten weiterhin
          ihre Zugriffsregeln.
        docsLabel: Wissen
  faq:
    heading: FAQ zu Agents
    items:
      - q: Was ist ein Agent in Tale?
        a:
          Ein Projektagent ist ein wiederverwendbarer Agent in einem Projekt.
          Laufzeit, Modell, Anweisungen und Tools bestimmen seine
          Arbeitsweise. Berichte und erzeugte Dateien bleiben zur Prüfung bei
          der Aufgabe.
      - q: Können wir eigene Abos oder API-Schlüssel nutzen?
        a:
          Ja. Verbinde eigene API-Zugangsdaten oder nutze ein unterstütztes
          Anthropic-Abo mit Claude Code beziehungsweise ein ChatGPT-Abo mit
          Codex für Aufgaben- und Automatisierungsagenten. Ein Administrator
          richtet die Zugangsdaten oder den Token-Broker ein. Chat braucht
          API-Zugangsdaten; Verfügbarkeit und Limits von Abos hängen vom
          Anbieter und Tarif ab.
      - q: Wann nutze ich einen Agent statt eines Workflows?
        a:
          Nutze einen Projektagenten für ein Ergebnis, das Tools, Dateien oder
          mehrere Arbeitsrunden braucht. Nutze eine Automatisierung, wenn du
          wiederholbare Schritte, Bedingungen oder Auslöser festlegen kannst.
      - q: Kann jeder Agent ein anderes Modell nutzen?
        a:
          Ja. Wähle für jeden Projektagenten ein Modell und einen Anbieter,
          passend zur Laufzeit und zum Modellangebot deiner Organisation.
          Änderungen gelten für spätere Läufe.
  docs:
    - label: Agent-Konzepte
      path: /platform/agents/concepts
    - label: Projekt-Agenten
      path: /platform/projects/project-agents
    - label: Agent-Laufzeiten
      path: /platform/agents/harnesses
    - label: Aufgaben-Automatisierung
      path: /platform/projects/task-automation
    - label: Wissen
      path: /platform/knowledge/overview
  tour:
    heading: So zeigen sich Agents in Tale
    description:
      Richte Agenten für ein Projekt ein, gib ihnen die nötigen Tools und den
      Kontext und verfolge ihre Arbeit anhand von Berichten und Ergebnissen.
    stages:
      - id: projects
        eyebrow: Projekte
        title: |-
          Agents nach Team
          abgrenzen
        description:
          Jedes Projekt hat eigene Agentenkonfigurationen. Der Projektzugriff
          bestimmt, wer die Agenten und ihre Aufgaben sehen kann.
      - id: knowledge
        eyebrow: Wissen
        title: |-
          Jeden Agent in dem
          verankern, was du weißt
        description: Füge Aufgabenbeschreibung und Referenzdateien hinzu und erteile
          Tools für zugängliches Unternehmenswissen. Sage dem Agenten klar,
          welche Quellen er verwenden soll.
  demos:
    knowledge:
      label:
        "Beispieldemo: Referenzmaterial, das ein Agent mit den passenden
        Wissenstools und Zugriffsrechten verwenden kann."
      source1: support-macros.pdf
      sourceType1: pdf
      source2: Brand Voice
      sourceType2: entry
      source3: agents.nordwind.eu
      sourceType3: website
      source4: returns-playbook.pdf
      sourceType4: pdf
    projects:
      label: 'Animierte Demo: Projekte so abgegrenzt, dass Support und Platform
        jeweils ihren Agent-Stack und ihre Mitglieder behalten.'
      project1: Support-Desk
      agents1: 4 Agenten
      members1: '9'
      project2: Platform Build
      agents2: 6 Agenten
      members2: '12'
      project3: Docs & Enablement
      agents3: 2 Agenten
      members3: '4'
      project4: Release-Zug
      agents4: 3 Agenten
      members4: '7'
platformAutomations:
  eyebrow: Automatisierungen
  title: Was sind Automatisierungen in Tale?
  description: Automatisierungen machen wiederkehrende Projektarbeit wiederholbar.
    Verbinde Modellaufrufe, Agentenschritte und Aktionen zu einem
    versionierten Workflow, teste ihn und starte ihn manuell oder über einen
    eingerichteten Auslöser.
  capabilities:
    heading: Abläufe definieren und wiederholen
    description:
      Halte Schritte, gespeicherte Versionen, Auslöser und Ausführungsverlauf
      zusammen. So kann dein Team nachvollziehen, wie wiederkehrende Arbeit
      ausgeführt wird.
    items:
      - title: Gespeicherte Versionen und Bereitstellung
        body:
          Speichere Änderungen als neue Workflow-Version. Stelle die Version
          für künftige Live-Läufe bereit. Laufende Ausführungen behalten ihre
          Startversion.
        docsLabel: Konzepte der Automatisierung
      - title: Typisierte Workflow-Schritte
        body:
          Verbinde Modellaufrufe, Agentenarbeit in Sandboxes,
          Datentransformationen, Unterautomatisierungen und angebundene
          Aktionen. Ergänze Bedingungen oder Wiederholungen, wo sie
          unterstützt werden.
        docsLabel: Workflow-Editor
      - title: Trigger, die zur Aufgabe passen
        body:
          Zeitpläne (Cron), Webhooks, Plattform-Events oder ein manueller Testlauf
          aus dem Editor.
        docsLabel: Trigger
      - title: Ausführungs-Logs
        body:
          Prüfe Status, Eingaben, Ausgaben und Schrittverlauf eines Laufs. Die
          erfassten Connector-Aktionen helfen dir nachzuvollziehen, was
          passiert ist.
        docsLabel: Ausführungs-Logs
      - title: Freigaben im Loop
        body: Connector-Regeln können geschützte Schreibzugriffe bis zur Freigabe
          anhalten. Ein Agentenschritt kann außerdem eine Person nach
          fehlenden Informationen fragen, bevor er fortfährt.
        docsLabel: Konzepte der Automatisierung
  faq:
    heading: FAQ zu Automatisierungen
    items:
      - q: Was ist eine Automatisierung in Tale?
        a:
          Eine Automatisierung definiert einen wiederholbaren Workflow mit
          Eingaben, Schritten und Ausgaben. Versionen, Bereitstellung,
          Auslöser und Ausführungsverlauf helfen deinem Team, den Ablauf zu
          testen und zu betreiben.
      - q: Gibt es ein eigenständiges Workflow-Produkt?
        a:
          Nein. Ein Workflow lebt in seiner Automatisierung. Der Editor-Tab der Automatisierung
          ist dort, wo du den Graphen triffst.
      - q: Wann nutze ich eine Automatisierung statt eines Agenten?
        a:
          Nutze eine Automatisierung für wiederholbare Schritte, Bedingungen,
          Zeitpläne oder angebundene Aktionen. Nutze einen Projektagenten für
          eine Aufgabe mit einem prüfbaren Ergebnis. Eine Automatisierung kann
          Agentenarbeit enthalten.
      - q: Kann ich einen Workflow testen, bevor er nach Zeitplan läuft?
        a:
          Ja. Teste eine gespeicherte Version vor der Bereitstellung oder dem
          Aktivieren eines Auslösers. Testläufe simulieren Connector-Aktionen.
          Live-Läufe können verbundene Systeme ändern und eine Freigabe
          erfordern.
  docs:
    - label: Konzepte der Automatisierung
      path: /platform/automations/concepts
    - label: Workflow-Editor
      path: /platform/automations/editor
    - label: Trigger
      path: /platform/automations/triggers
    - label: Ausführungs-Logs
      path: /platform/automations/execution-logs
    - label: Integrierte Automatisierungen
      path: /platform/automations/builtin
  tour:
    heading: So laufen Automatisierungen in Tale
    description: Definiere den Ablauf, wähle die nötigen Schritte und Daten und prüfe
      jeden Lauf. Lege Freigaberegeln für geschützte Connector-Schreibzugriffe
      fest.
    stages:
      - id: govern
        eyebrow: Freigaben
        title: |-
          Human-in-the-Loop
          bevor es rausgeht
        description:
          Wenn die Regeln eine Freigabe verlangen, wartet ein
          Connector-Schreibzugriff auf eine Person. Die Freigabe erlaubt den
          Ausführungsversuch, eine Ablehnung verhindert ihn.
      - id: agents
        eyebrow: Agenten
        title: |-
          Gib einem Agenten
          einen Workflow-Schritt
        description:
          Konfiguriere einen Agentenschritt mit eigener Laufzeit, Modell,
          Anweisungen und Ausstattung. Nutze einen Modellaufruf, wenn eine
          einzelne Antwort genügt.
  demos:
    automation:
      label:
        "Animierte Demo: Eine Rechnungs-Pipeline extrahiert Positionen, hält
        Beträge über CHF 5'000 zur Freigabe an und bucht den Rest ins ERP; die
        Ausführungen-Tabelle hält jeden Lauf fest."
      trigger: Neue Rechnung
      llm: Posten lesen
      condition: Ab CHF 5'000?
      branchYes: Ja
      action: Freigeben lassen
      actionAlt: Ins ERP buchen
      run1: '#1207'
      runTone1: done
      duration1: 4,8s
      run2: '#1208'
      runTone2: pending
      duration2: —
      run3: '#1209'
      runTone3: running
      duration3: 1,2s
    govern:
      label: "Beispieldemo: Ein Rechnungsworkflow wartet in der Laufansicht auf die
        Freigabe eines Connector-Schreibzugriffs. Nach der Freigabe wird das
        Ausführungsergebnis erfasst."
      approvalTitle: 7 Rechnungen über CHF 23'410 ins ERP buchen?
      requester: 'Rechnungs-Pipeline · Lauf #1208'
      audit1: Freigegeben von finance@nordwind.eu
      audit2: 7 Rechnungen ins ERP gebucht
      audit3: 'Lauf #1208 in 41s abgeschlossen'
      budgetValue: CHF 1'240 / 2'500
    connect:
      label:
        "Beispieldemo: Benannte Agenten für Rechnungen, Lieferanten, ERP,
        Abgleich und Ausnahmefälle. Agentenschritte in Workflows haben eine
        eigene Konfiguration."
      agent1: Invoice-Agent
      model1: Claude Sonnet
      agent2: Lieferanten-Agent
      model2: GPT-5.5
      agent3: ERP-Agent
      model3: Claude Opus
      agent4: Matching-Agent
      model4: Claude Sonnet
      agent5: Exceptions-Agent
      model5: GPT-5.5
    projects:
      label:
        "Beispieldemo: Projekte organisieren die Aufgaben und Agenten für
        wiederkehrende Workflows."
      project1: Invoice-Ops
      agents1: 3 Agenten
      members1: '6'
      project2: Lieferantenaufnahme
      agents2: 2 Agenten
      members2: '4'
      project3: Engineering-CI
      agents3: 4 Agenten
      members3: '10'
      project4: Nächtliche Reviews
      agents4: 2 Agenten
      members4: '5'
platformChat:
  eyebrow: Chats
  title: Fragen klären, vergleichen, Arbeit übergeben
  description:
    Nutze den Chat, um ein Problem zu verstehen, Projektquellen auszuwerten
    und einen Auftrag vorzubereiten. Braucht die Arbeit Dateien, Code oder
    Werkzeuge, erstelle eine Projektaufgabe und weise sie einem Agenten zu.
  capabilities:
    heading: Was umfasst Chat?
    description: Gehe einer Frage nach, prüfe die Quellen und bereite die nächste Aufgabe
      vor.
    items:
      - title: Ein Modell wählen
        body:
          Wähle ein verfügbares Modell mit Anbieter oder lass Auto für jede
          Nachricht ein Modell nach den Regeln deiner Organisation auswählen.
        docsLabel: Chat-Grundlagen
      - title: Quellen prüfen
        body:
          Öffne die Dokumente und Seiten, die eine Antwort verwendet hat.
          Prüfe, ob die Quellen die Schlussfolgerung stützen.
        docsLabel: Chat-Grundlagen
      - title: Zwei Modelle in Arena vergleichen
        body:
          Sende denselben Prompt mit demselben Ausgangskontext an zwei
          Modelle. Lies beide Antworten und entscheide, wie du fortfahren
          willst.
        docsLabel: Arena-Modus
      - title: Die passenden Dateien mitgeben
        body:
          Hänge unterstützte Dokumente, Bilder oder Aufnahmen an. Verarbeitung
          und Modellfähigkeiten bestimmen, was der Assistent lesen kann.
        docsLabel: Anhänge
      - title: Vom Gespräch zur Aufgabe wechseln
        body:
          Erstelle aus dem Gespräch eine Projektaufgabe, wenn ein Agent
          Dateien erstellen oder in einer Sandbox arbeiten soll.
        docsLabel: Projektagenten
  faq:
    heading: FAQ zu Chat
    items:
      - q: Was ist der Chat in Tale?
        a:
          Der Chat nutzt den integrierten Assistenten für Fragen, die Suche
          nach Quellen und Textentwürfe. Er kann zugängliches
          Unternehmenswissen und den Kontext des aktuellen Projekts verwenden.
      - q: Brauche ich für den Chat einen Projektagenten?
        a:
          Nein. Der Chat nutzt Tales integrierten Assistenten mit deinem
          gewählten Modell. Projektagenten sind eigenständige Bearbeiter,
          denen du Projektaufgaben zuweist.
      - q: Was ist der Arena-Modus?
        a:
          Arena sendet einen Prompt mit demselben Ausgangskontext an zwei
          Modelle. Du vergleichst die Antworten und hältst eine Bewertung
          fest, bevor du das Gespräch fortsetzt.
      - q: Wie wird aus einem Chat konkrete Arbeit?
        a:
          Erstelle aus dem Gespräch eine Projektaufgabe und weise einen
          Agenten zu. Der Chat selbst führt keinen Code aus, ändert keine
          angebundenen Systeme und erstellt keine Ergebnisdateien. Fortschritt
          und Ergebnis der Aufgabe bleiben mit dem Gespräch verknüpft.
  docs:
    - label: Chat-Übersicht
      path: /platform/chat/overview
    - label: Chat-Grundlagen
      path: /platform/chat/basics
    - label: Arena-Modus
      path: /platform/chat/arena-mode
    - label: Projektagenten
      path: /platform/agents/concepts
    - label: Anhänge
      path: /platform/chat/attachments
  tour:
    heading: So funktioniert Chat in Tale
    description: Besprich das Problem im Chat und nutze Projektaufgaben und
      Automatisierungen für die anschließende Arbeit.
    stages:
      - id: projects
        eyebrow: Projekte
        title: |-
          Gespräche bei
          der Arbeit halten
        description:
          Nutze Projektchats mit gemeinsamem Kontext und wähle, welche
          Gespräche du mit Projektmitgliedern teilst. Aufgaben, Dateien und
          Anweisungen bleiben im selben Projekt.
      - id: knowledge
        eyebrow: Wissen
        title: |-
          Antworten anhand
          der Quellen prüfen
        description:
          Der Chat kann zugängliches Wissen und Projektdateien abrufen. Öffne
          die Quellen einer Antwort und prüfe sie, bevor du das Ergebnis
          nutzt.
  demos:
    arena:
      label:
        "Beispieldarstellung: Zwei Modelle entwerfen in Arena eine Ankündigung
        aus demselben Release-Briefing."
      prompt: Entwirf eine Ankündigung aus dem angehängten Release-Briefing.
      modelA: Claude Sonnet
      modelB: GPT-5.5
      replyA1:
        Beginne mit der wichtigsten Verbesserung aus dem Briefing.
      replyA2: Erkläre, wem sie hilft, und zitiere die passende Release-Notiz.
      replyA3: Schließe mit dem dokumentierten nächsten Schritt.
      replyB1: Beginne mit dem Kundenproblem, das die Version löst.
      replyB2: Liste die Änderungen mit einem Link zur jeweiligen Quelle.
      replyB3: Nenne zum Schluss die Angaben zur Einführung aus dem Briefing.
    projects:
      label:
        "Beispieldarstellung: Projekte halten zugehörige Chats, Aufgaben,
        Dateien und Agenten zusammen."
      project1: Support-Threads
      agents1: 3 Agenten
      members1: '8'
      project2: Engineering-Chat
      agents2: 5 Agenten
      members2: '11'
      project3: Comms-Entwürfe
      agents3: 2 Agenten
      members3: '4'
      project4: Pilot-War-Room
      agents4: 3 Agenten
      members4: '6'
    knowledge:
      label:
        'Animierte Demo: Die Quellen, die Chat für eine gestützte Antwort holt —
        Release-Notes-PDF, Changelog-Crawl, Ankündigungs-Vorlage und
        Brand-Voice-Eintrag.'
      source1: release-notes-2.4.pdf
      sourceType1: pdf
      source2: changelog.nordwind.eu
      sourceType2: website
      source3: Ankündigungs-Vorlage
      sourceType3: entry
      source4: Ton-Guide
      sourceType4: entry
platformGovernance:
  eyebrow: Richtlinien
  title: Regeln für dein Team und deine Agenten
  description:
    Steuere Zugriffe, konfiguriere Genehmigungen für Connector-Aktionen und
    prüfe protokollierte Vorgänge. Lege Modellbudgets und Chat-Filter für die
    Arbeit deines Teams und seiner Agenten fest.
  capabilities:
    heading: Was umfasst Governance?
    description: Lege fest, welche Connector-Schreibaktionen eine Genehmigung brauchen,
      welche Werkzeuge Agenten nutzen dürfen und welche Inhalts- und
      Nutzungsregeln gelten.
    items:
      - title: Connector-Schreibaktionen genehmigen
        body: Connector-Schreibaktionen in Automatisierungen warten auf
          Genehmigung, wenn deine Richtlinie es verlangt. Für externe
          Schreibaktionen gilt das standardmäßig; Lesezugriffe und interne
          Plattformaktionen haben andere Regeln.
        docsLabel: Genehmigungen verstehen
      - title: Die vorgeschlagene Aktion prüfen
        body:
          Prüfe Ziel und genaue Eingabe vor der Genehmigung. Lehne eine
          fehlerhafte Aktion ab, korrigiere Ablauf oder Eingabe und starte
          eine neue Ausführung.
        docsLabel: Genehmigungen verstehen
      - title: Das Prüfprotokoll lesen
        body:
          Prüfe aufgezeichnete Aktionen und Genehmigungsentscheidungen mit
          handelnder Person und Zeitpunkt. Nutze das Prüfprotokoll, um
          Vorgänge nachzuvollziehen.
        docsLabel: Prüfprotokolle
      - title: Organisationsregeln festlegen
        body:
          Konfiguriere gemeinsame Anweisungen, Zugriffsregeln und
          Werkzeugfreigaben für Agenten. Durchgesetzte Rechte und Filter
          ergänzen die Anweisungen an ein Modell.
        docsLabel: Schutzregeln
      - title: Chat-Inhaltsfilter konfigurieren
        body:
          Aktiviere Inhaltsschutz, Erkennung personenbezogener Daten und
          optionale Moderation für die gewünschten Chat-Richtungen. Teste
          passende Muster und das Verhalten bei Fehlern.
        docsLabel: Schutzregeln
      - title: Budgets für erfasste Nutzung setzen
        body: Verfolge erfasste Modellnutzung und lege Budgets für unterstützte
          Zugriffswege fest, darunter verwaltete Agentenausführungen. Direkte
          Abonnementaufrufe nutzen die Kontrollen des Anbieters.
        docsLabel: Nutzungsanalyse
  faq:
    heading: FAQ zu Governance
    items:
      - q: Was steuert die Governance?
        a:
          Governance umfasst Zugriffsregeln, Genehmigungsrichtlinien für
          Connectors, Prüfereignisse, Nutzungsbudgets und konfigurierbare
          Chat-Filter. Jede Kontrolle hat einen eigenen Geltungsbereich.
      - q: Wo entscheide ich über eine Connector-Genehmigung?
        a:
          Öffne die wartende Automatisierungsausführung. Arbeitet sie an einer
          Aufgabe, erscheint die Genehmigungskarte auch dort.
          Connector-Genehmigungen sind von der Prüfung eines abgeschlossenen
          Agentenergebnisses getrennt.
      - q: Kann ich festlegen, welche Connector-Schreibaktionen eine
          Genehmigung brauchen?
        a:
          Ja. Die Richtlinie lässt sich für einen Connector oder eine einzelne
          Aktion festlegen. Externe Schreibaktionen brauchen standardmäßig
          eine Genehmigung. Eine Richtlinienänderung entscheidet keine bereits
          wartende Anfrage.
      - q: Wartet jede Agentenaktion auf Genehmigung?
        a:
          Nein. Der Connector-Broker stellt Agenten Leseaktionen bereit;
          genehmigungspflichtige Connector-Schreibaktionen laufen über
          Automatisierungsknoten. Direkte GitHub-Werkzeuge und ausdrücklich
          freigegebene Secrets haben eigene Zugriffswege. Prüfe auch diese
          Freigaben.
      - q: Wie gelten Inhaltsfilter und Datenkontrollen?
        a: Chat-Filter können die konfigurierten Ein- und Ausgaben prüfen.
          Modell-API-Endpunkte filtern nur Eingaben, keine Modellausgaben. Die
          Erkennung personenbezogener Daten hängt von den eingerichteten
          Mustern ab. Bewerte Betrieb, Anbieter und Verfahren gemeinsam.
  docs:
    - label: Freigabe-Konzepte
      path: /platform/approvals/concepts
    - label: Freigaben konfigurieren
      path: /platform/approvals/configure
    - label: Freigaben in Workflows
      path: /platform/automations/approvals-in-workflows
    - label: Audit-Logs
      path: /platform/admin/governance/audit-logs
    - label: Guardrails
      path: /platform/admin/governance/guardrails
  tour:
    heading: Regeln bei der Arbeit nachvollziehen
    description: Prüfe Ablaufausführungen, vergleiche Antworten und kontrolliere die
      Werkzeuge und Quellen, die Agenten nutzen können.
    stages:
      - id: automations
        eyebrow: Automatisierungen
        title: |-
          Ausführung und
          Entscheidungen prüfen
        description:
          Ein eingerichteter Ablauf kann einen Zugriffsbericht auswerten und
          eine Benachrichtigung vorbereiten. Prüfe Schritte,
          Genehmigungsentscheidungen und protokollierte Auswirkungen in den
          Ausführungsdetails.
      - id: agents
        eyebrow: Agenten
        title: |-
          Die nötigen
          Werkzeuge freigeben
        description:
          Gib jedem Projektagenten gezielt Werkzeuge und Zugangsdaten.
          Verwaltete Modellaufrufe nutzen Tales Gateway-Kontrollen; direkte
          Abonnementzugriffe nehmen einen anderen Weg.
  demos:
    govern:
      label:
        "Beispieldarstellung: Eine Automatisierung fragt nach Genehmigung,
        bevor ein Connector eine Richtlinienänderung per E-Mail versendet, und
        protokolliert Entscheidung und Ausführung."
      approvalTitle: Die Richtlinienänderung an das Projektteam senden?
      requester: Richtlinienablauf · E-Mail-Connector
      audit1: Freigegeben von lena@nordwind.eu
      audit2: E-Mail zur Richtlinienänderung versendet
      audit3: 'Audit-Eintrag #8841 geschrieben'
      budgetValue: CHF 220 / 800
    automation:
      label: "Beispieldarstellung: Ein eingerichteter, geplanter Ablauf prüft einen
        Zugriffsbericht und bereitet eine Slack-Benachrichtigung vor."
      trigger: Täglich 01:00
      llm: Rechte prüfen
      condition: Neue Admins?
      branchYes: Ja
      action: '#security-Alarm'
      actionAlt: Bericht ablegen
      run1: '#98'
      runTone1: done
      duration1: 3,4s
      run2: '#99'
      runTone2: done
      duration2: 3,1s
      run3: '#100'
      runTone3: running
      duration3: 0,6s
    connect:
      label: "Beispieldarstellung: Projektagenten mit verschiedenen Aufgaben und
        ausgewählten Modellen; Werkzeuge und Berechtigungen werden gesondert
        festgelegt."
      agent1: Policy-Agent
      model1: Claude Sonnet
      agent2: Audit-Agent
      model2: Claude Opus
      agent3: Budget-Agent
      model3: GPT-5.5
      agent4: Access-Agent
      model4: Claude Sonnet
      agent5: Exceptions-Agent
      model5: Claude Opus
platformHub:
  title: Wie funktioniert die Tale-Plattform?
  description: Tale bringt Teammitglieder und KI-Agenten in einem Projektarbeitsbereich
    zusammen. Plane Aufgaben auf Boards, delegiere sie an Agenten in Sandboxes
    und prüfe die Ergebnisse mit dem zugehörigen Kontext und den Dateien.
  modulesHeading: Plattform-Module
  modulesDescription:
    Projekte organisieren die Arbeit. Agenten bearbeiten zugewiesene Aufgaben.
    Chat und Wissen liefern Kontext. Automatisierungen machen Schritte
    wiederholbar; Governance regelt Zugriff und Prüfung.
  tour:
    heading: So fügt sich die Plattform zusammen
    description:
      Plane ein Projekt, statte Agenten für seine Aufgaben aus und prüfe ihre
      Ergebnisse. Wissen, Chat und wiederholbare Workflows unterstützen die
      gemeinsame Arbeit.
    stages:
      - id: agents
        eyebrow: Agenten
        title: |-
          Agenten für
          deine Projektaufgaben
        description: Konfiguriere Projektagenten mit einer unterstützten Laufzeit, einem
          Modell und Tools. Weise ihnen Aufgaben zu und verfolge den
          Fortschritt mit deinem Team.
      - id: projects
        eyebrow: Projekte
        title: Nach Team abgrenzen
        description:
          Bündle Aufgaben, Agenten, Dateien und Anweisungen in einem Projekt.
          Lege den Zugriff fest und teile gezielt die Chats, die dein Team
          lesen soll.
  faq:
    heading: Plattform-FAQ
    items:
      - q: Was ist die Plattform in Tale?
        a:
          Tale ist ein Open-Source-Projektarbeitsbereich für Teams und
          KI-Agenten. Plane Aufgaben, delegiere Arbeit, verfolge den
          Fortschritt und prüfe Ergebnisse mit gemeinsamem Kontext und
          wiederholbaren Workflows.
      - q: Welche Module gehören zu Tale?
        a:
          Chat, Projekte, Wissen, Agenten, Automatisierungen und Richtlinien — die Projekte
          grenzen Arbeit, Dateien und Agenten nach Team ab.
      - q: Ist Tale Open Source?
        a:
          Ja. Community ist Open Source und kostenlos selbst gehostet. Enterprise
          ergänzt Support und Services auf derselben Codebasis.
      - q: Wo fange ich an?
        a:
          Starte mit einem Projekt und einer Aufgabe, deren Ergebnis du
          beurteilen kannst. Füge passende Dateien hinzu, weise einen
          eingerichteten Agenten zu, starte ihn und prüfe sein Ergebnis.
  demos:
    connect:
      label: 'Animierte Demo: Der Hub-Agenten-Sampler — Orchestrator-Agent,
        Support-Agent, Docs-Agent, Invoice-Agent und Policy-Agent, jeweils mit
        Modell.'
      agent1: Orchestrator-Agent
      model1: Claude Sonnet
      agent2: Support-Agent
      model2: Claude Sonnet
      agent3: Docs-Agent
      model3: Claude Opus
      agent4: Invoice-Agent
      model4: GPT-5.5
      agent5: Policy-Agent
      model5: Claude Opus
    projects:
      label:
        'Animierte Demo: Hub-Projekte-Sampler — Platform Core, Kunden-Piloten,
        Partner-Enablement und Internal Ops, jeweils mit eigenem Roster.'
      project1: Platform Core
      agents1: 6 Agenten
      members1: '12'
      project2: Kunden-Piloten
      agents2: 3 Agenten
      members2: '7'
      project3: Partner-Enablement
      agents3: 2 Agenten
      members3: '5'
      project4: Internal Ops
      agents4: 4 Agenten
      members4: '9'
platformKnowledge:
  eyebrow: Wissen
  title: Was ist Wissen in Tale?
  description: Halte Dokumente, kurze Fakten, Website-Inhalte und strukturierte
    Datensätze für dein Team bereit. Chat und passend ausgestattete
    Projektagenten können zugängliche Quellen für Antworten und Aufgaben
    abrufen.
  capabilities:
    heading: Was steckt in Wissen?
    description:
      Bereite hilfreiche Quellen für die Suche auf und prüfe die Belege hinter
      Antworten und Ergebnissen.
    items:
      - title: Dokumente mit Indexierungs-Pipeline
        body:
          Lade unterstützte Dateien hoch und prüfe ihren Indexierungsstatus.
          Indexierter Text lässt sich mit Quellenangaben abrufen.
        docsLabel: Dokumente
      - title: Wissenseinträge
        body:
          Speichere einen kurzen Fakt unter einem beständigen Thema.
          Aktualisiere den Eintrag bei Änderungen und prüfe seine
          Versionshistorie.
        docsLabel: Wissenseinträge
      - title: Website-Crawls
        body:
          Indexiere Seiten, die Agents zitieren sollen, ohne sie in Prompts zu
          pasten.
        docsLabel: Crawling
      - title: Typisierte Datensätze
        body:
          Kontakte und Produkte bündeln benannte Felder. Menschen und Agenten
          können konkrete Werte nachschlagen und ergänzende Dokumente
          hinzuziehen.
        docsLabel: Strukturierte Daten
      - title: Zugriff nach den Regeln der Quelle
        body:
          Teambeschränkungen und Projektzugriffe gelten auch bei der Suche.
          Projektagenten brauchen die passenden Plattform-Tools, um Wissen
          abzurufen.
        docsLabel: Wissen im Überblick
  faq:
    heading: FAQ zu Wissen
    items:
      - q: Was ist Wissen in Tale?
        a:
          Wissen enthält gemeinsame Dokumente, Einträge, indexierte Websites,
          Kontakte und Produkte. Schaffe damit eine gemeinsame Grundlage für
          Fragen und Projektaufgaben und prüfe die verwendeten Quellen.
      - q: Was bestimmt, welche Quellen abrufbar sind?
        a: Die Suche berücksichtigt Quellberechtigungen und Projektkontext.
          Projektchats können eigene Projektdateien und zugängliches
          Organisationswissen durchsuchen. Projektagenten brauchen dafür die
          passenden Tools.
      - q: Was ist der Unterschied zwischen Dokumenten und typisierten Datensätzen?
        a:
          Dokumente und Einträge liefern Text für die Suche. Kontakte und
          Produkte speichern benannte Felder zum gezielten Nachschlagen. Prüfe
          in beiden Fällen die Quelle und ihre Aktualität.
      - q: Wie wird aus einem hilfreichen Fakt gemeinsames Wissen?
        a:
          Personen mit Bearbeitungsrecht können Wissenseinträge anlegen oder
          aktualisieren; Integrationen können sie über die API pflegen. Prüfe
          einen Fakt vor dem Speichern. Chat fügt der Bibliothek nicht
          automatisch Fakten hinzu.
  docs:
    - label: Wissen im Überblick
      path: /platform/knowledge/overview
    - label: Dokumente
      path: /platform/knowledge/documents
    - label: Wissenseinträge
      path: /platform/knowledge/knowledge-entries
    - label: Crawling
      path: /platform/knowledge/crawling
    - label: Strukturierte Daten
      path: /platform/knowledge/structured-data
  tour:
    heading: So verankert Wissen Tale
    description:
      Bereite Unternehmensquellen auf, nutze sie für Fragen und
      Projektaufgaben und prüfe die Belege hinter dem Ergebnis.
    stages:
      - id: chat
        eyebrow: Chat
        title: |-
          Öffne die Quellen
          hinter einer Antwort
        description:
          Abgerufene Passagen landen als Zitat-Karten — Leser öffnen die
          Datei oder Seite, die die Antwort genutzt hat.
      - id: projects
        eyebrow: Projekte
        title: |-
          Bibliotheken wohnen
          bei ihren Teams
        description:
          Projekte legen fest, welche Dokumente neben welchen Agents und
          Mitgliedern liegen.
  demos:
    knowledge:
      label:
        'Animierte Demo: Die Org-Bibliothek indexiert das Produkthandbuch, den
        Docs-Site-Crawl, die Preisliste 2026 und einen Onboarding-FAQ-Eintrag.'
      source1: produkthandbuch-v4.pdf
      sourceType1: pdf
      source2: docs.nordwind.eu
      sourceType2: website
      source3: Preisliste 2026
      sourceType3: catalog
      source4: Onboarding-FAQ
      sourceType4: entry
    hero:
      label: "Beispieldemo: Ein Chat beantwortet eine Produktfrage mit abgerufenen
        Textstellen und zeigt Quellenangaben zu einem Handbuch und einem
        FAQ-Eintrag."
      prompt: Was hat sich in Handbuch v4 bei der Akkupflege im Winter geändert?
      routedTitle: Modell ausgewählt
      routedDetail: Claude Sonnet antwortet mit abgerufenen Produktquellen.
      reply1: V4 engt die Langzeitlagerung auf 10–20 °C ein, ab 30 Tagen Standzeit.
      reply2: Vor dem Einlagern auf 60 % laden — volle Ladung altert die Zellen
        schneller.
      reply3: Der Enteisungs-Hinweis ist in die Quick-Start-Beilage gewandert —
      reply4: und Firmware 3.2 bringt eine Ladesperre bei Minustemperaturen.
      citation1: produkthandbuch-v4.pdf
      citation2: Onboarding-FAQ
      composerModel: Claude Sonnet
    projects:
      label: 'Animierte Demo: Projekte, die Bibliotheken neben den Agenten und
        Mitgliedern halten, die sie nutzen.'
      project1: Produkt-Korpus
      agents1: 3 Agenten
      members1: '7'
      project2: Support-Makros
      agents2: 2 Agenten
      members2: '9'
      project3: Policy-Regal
      agents3: 2 Agenten
      members3: '5'
      project4: Engineering-Wiki
      agents4: 4 Agenten
      members4: '12'
platformProjects:
  eyebrow: Projekte
  title: Was sind Projekte in Tale?
  description: Bringe Teammitglieder, Aufgaben, Projektagenten und Referenzdateien für
    ein gemeinsames Ziel zusammen. Plane die Arbeit auf dem Board, starte
    Agentenaufgaben und prüfe die Ergebnisse mit deinem Team.
  capabilities:
    heading: Ein Arbeitsbereich pro Vorhaben
    description: Koordiniere einen Launch, eine Recherche oder eine interne Verbesserung
      mit einem gemeinsamen Board, Projektanweisungen und passend
      ausgestatteten Agenten.
    items:
      - title: Kontext, der bei der Arbeit bleibt
        body: Bündle Aufgaben, Anweisungen und Referenzdateien in einem Projekt.
          Projektchats nutzen dessen Anweisungen und können relevante Dateien
          abrufen.
        docsLabel: Projekt-Überblick
      - title: Ein Board, von dem Agents arbeiten
        body:
          Weise eine Aufgabe einem Projektagenten zu und starte sie. Verfolge
          den Fortschritt und prüfe den Bericht und die angehängten Dateien,
          sobald der Agent fertig ist.
        docsLabel: Aufgaben-Automatisierung
      - title: Ein Backlog für vorgeschlagene Arbeit
        body:
          Sammle Ideen und von Agenten vorgeschlagene Aufgaben im Backlog.
          Kläre den Auftrag, weise die Aufgabe zu und entscheide, was
          gestartet wird.
        docsLabel: Projekt-Backlog
      - title: Dateien, die im Projekt bleiben
        body: Ordne Referenzdateien im Wissen-Tab des Projekts. Indexierte Inhalte
          sind im Projektkontext verfügbar; dabei gelten die Zugriffsregeln.
        docsLabel: Dateien verwalten
      - title: Agenten für dein Projekt ausstatten
        body:
          Erstelle Projektagenten mit Rolle, kompatibler Laufzeit und Modell,
          Anweisungen und Tools. Weise die Arbeit dem dafür ausgestatteten
          Agenten zu.
        docsLabel: Projekt-Agenten
  faq:
    heading: Projekte-FAQ
    items:
      - q: Was ist ein Projekt in Tale?
        a: Ein geteilter Arbeitsbereich, der Chats, Dateien, Anweisungen und
          Aufgaben zu einem Vorhaben bündelt — ein Kontakt, ein Launch, eine
          Recherche — damit der Kontext bei der Arbeit bleibt.
      - q: Wie arbeiten Agents an Projektaufgaben?
        a:
          Weise eine Aufgabe zu und starte dann den Agenten oder verschiebe
          die Aufgabe auf In Bearbeitung. Der Agent arbeitet in seiner Sandbox
          und liefert einen Bericht und Dateien zur Prüfung. Eine Person oder
          ein separat zugewiesener Prüfagent kann das Ergebnis prüfen. Die
          Zuweisung allein startet keinen Lauf.
      - q: Wer sieht die Chats und Dateien eines Projekts?
        a:
          Projekte sind standardmäßig für die ganze Organisation zugänglich.
          Beschränke den Projektzugriff bei Bedarf auf ausgewählte Teams;
          Administratoren behalten Zugriff. Chats bleiben persönlich, bis sie
          ausdrücklich geteilt werden – auch Chats innerhalb eines Projekts.
      - q: Was unterscheidet ein Projekt von einem Chat?
        a:
          Ein Chat ist ein Gespräch mit einem KI-Assistenten. Ein Projekt
          organisiert laufende Arbeit mit Aufgabenboard, Agenten, Anweisungen,
          Dateien und Chats. Ein neuer Chat nutzt die Projektanweisungen,
          übernimmt aber nicht automatisch frühere Gespräche.
  docs:
    - label: Projekt-Überblick
      path: /platform/projects/overview
    - label: Projekt-Konzepte
      path: /platform/projects/concepts
    - label: Aufgaben-Automatisierung
      path: /platform/projects/task-automation
    - label: Projekt-Backlog
      path: /platform/projects/backlog
    - label: Dateien verwalten
      path: /platform/projects/manage-files
    - label: Projekt-Agenten
      path: /platform/projects/project-agents
  tour:
    heading: Wie Projekte Arbeit erledigen
    description:
      Plane die Arbeit mit deinem Team, delegiere Aufgaben an Agenten und
      prüfe ihre Berichte. Projektanweisungen und Referenzdateien unterstützen
      die Arbeit.
    stages:
      - id: tasks
        eyebrow: Aufgaben
        title: |-
          Aufgabe zuweisen,
          dann Agenten starten
        description:
          Formuliere einen klaren Auftrag und weise einen Projektagenten zu.
          Starte die Arbeit, verfolge den Fortschritt und prüfe den Bericht
          und die Dateien, die der Agent zur Prüfung zurückgibt.
      - id: chat
        eyebrow: Chats
        title: |-
          Gib Projektchats
          eine gemeinsame Grundlage
        description:
          Projektanweisungen gelten für die zugehörigen Chats. Der Assistent
          kann relevante Projektdateien abrufen. Ergänze frühere
          Entscheidungen, die ein neues Gespräch braucht.
  demos:
    hero:
      label:
        "Beispieldemo: Ein Projektchat nutzt Projektanweisungen und abgerufene
        Referenzdateien, um eine Frage zum Website-Relaunch zu beantworten."
      prompt: Was fehlt noch, bevor der Relaunch live geht?
      routedTitle: Modell ausgewählt
      routedDetail: Der Chat-Assistent nutzt Projektanweisungen und ruft relevante Dateien
        ab.
      reply1:
        Die Launch-Checkliste nennt noch die Prüfung der Weiterleitungen und
        die Texte der Preisseite.
      reply2:
        Sobald beides bereit ist, sieht sie einen Test in der Staging-Umgebung
        vor.
      reply3: Der DNS-Umzug ist mit der IT für Donnerstag 06:00 gebucht,
      reply4: und die Checkliste führt die ungetestete /docs-Weiterleitung als
        offenes Risiko auf.
      citation1: launch-checkliste.pdf
      citation2: Redirect-Map
      composerModel: Claude Opus
    govern:
      label:
        "Beispieldemo: Ein konfigurierter Veröffentlichungsworkflow wartet auf
        die Connector-Freigabe, bevor er versucht, die neue Preisseite zu
        veröffentlichen."
      approvalTitle: Neue Pricing-Seite in Produktion veröffentlichen?
      requester: Website-Relaunch · Veröffentlichungsworkflow
      audit1: Freigegeben von mira@nordwind.eu
      audit2: Pricing-Seite veröffentlicht
      audit3: Entscheidung im Audit-Protokoll erfasst
      budgetValue: CHF 120 / 400
    tasks:
      label:
        "Animierte Demo: Das Website-Relaunch-Board. Der Relaunch-Agent arbeitet an WEB-12 in In Bearbeitung, während WEB-11 in In Prüfung wartet."
      id1: WEB-14
      title1: /docs-Redirect-Map fertigstellen
      assignee1: Nicht zugewiesen
      id2: WEB-15
      title2: Pricing-Hero-Copy neu schreiben
      assignee2: Mira
      id3: WEB-12
      title3: Migrationsleitfaden für den Relaunch entwerfen
      assignee3: Relaunch Agent
      id4: WEB-11
      title4: Staging-Checkliste freigeben
      assignee4: Relaunch Agent
      id5: WEB-9
      title5: Brand-Token-Set veröffentlichen
      assignee5: Design Agent
pricingPage:
  relatedHeading: Weiterführend
  ctaTitle: Lass dir dein Setup durchrechnen
  ctaDescription: Fordere eine Demo an oder sprich mit dem Team über
    Enterprise-Sitze, Speicher und Hardware.
  faq:
    heading: Preise FAQ
    items:
      - q: Was kostet Tale Enterprise?
        a:
          Tale Enterprise kostet CHF 12 (EUR 14) pro User und Monat, bei jährlicher
          Abrechnung zwei Monate gratis. Speicher kostet CHF 10 (EUR 12) pro TB
          und Monat.
      - q: Ist Community kostenlos?
        a:
          Ja. Die Community-Edition kannst du kostenlos als Open Source selbst
          hosten.
      - q: Kann ich Hardware mit Software kaufen?
        a:
          Ja. Leise Inference-Hardware gibt es zum Mieten, Leasen oder Kaufen — siehe
          Hardware-Preise.
changelogPage:
  eyebrow: Changelog
  title: Was ist neu in Tale?
  description: Release Notes zu Tale, neueste zuerst — veröffentlicht aus GitHub Releases.
  allReleases: Alle Releases
  sourceNote: 'Quelle:'
  githubLink: GitHub Releases
  viewOnGithub: Auf GitHub ansehen
  emptyBody: Keine Release Notes für diese Version.
  fetchedAt: Zuletzt aktualisiert am {date}.
contentPages:
  comparisons:
    directoryTitle: Finde deinen Vergleich
    directoryDescription: Suche ein Produkt, das du kennst, oder grenze die Leitfäden nach deiner Entscheidung ein.
    searchLabel: Vergleiche durchsuchen
    searchPlaceholder: Produktname oder Thema
    filterLabel: Art des Vergleichs
    resultCount: '{count} von {total} Leitfäden'
    emptyTitle: Keine passenden Vergleiche
    emptyDescription: Suche nach einem anderen Produkt oder Thema. Setze Suche und Filter zurück, um alle Leitfäden zu sehen.
    reset: Alle Vergleiche anzeigen
    sameBrief: Ein Briefing, zwei Ansätze
    workspace: Gemeinsamer Projektarbeitsbereich
    criteriaLabel: Was dieser Leitfaden vergleicht
    types:
      all:
        label: Alle Leitfäden
        description: Vergleiche den Ablauf, den dein Team braucht, und prüfe auch, wie unterschiedliche Produkte zusammenpassen.
      direct:
        label: Teamplattformen
        description: Vergleiche Produkte, mit denen Menschen und Agenten Arbeit koordinieren, Aufgaben delegieren und Ergebnisse gemeinsam prüfen.
      adjacent:
        label: Assistenten & Werkzeuge
        description: Vergleiche Assistenten, Workflow-Werkzeuge und App-Builder mit einem gemeinsamen Projektarbeitsbereich.
      framework:
        label: Frameworks
        description: Entscheide, ob du einen Arbeitsbereich einsetzen oder eine eigene Agentenanwendung mit Teamoberfläche bauen möchtest.
      runtime:
        label: Agent-Laufzeiten
        description: Unterscheide zwischen einer kompatiblen Agent-Laufzeit und dem Arbeitsbereich, der sie umgibt.
  tableScrollHint: Zum Vergleichen seitlich scrollen
  breadcrumb: Seitenpfad
  reviewed: 'Geprüft am {date}'
  relatedTitle: Aufgaben für dein Team
  relatedDescription: Beginne mit einem klaren Briefing, definierten Ergebnissen und einem Prüfprozess.
  nextTitle: Probiere es mit deinem eigenen Projekt aus
  nextDescription: Bring eine konkrete Aufgabe und die Werkzeuge mit, die dein Team bereits nutzt.
  allUseCases: Alle Anwendungsfälle

demo:
  pages:
    home:
      label: "Die Aufgabenansicht von Tale zum Prüfen eines Launch-Briefings und zum Besprechen des nächsten Schritts."
      caption: "Die Aufgabe, ihr Kontext und die nächste Entscheidung an einem Ort."
    hub:
      label: "Der Tale-Posteingang zum Lesen von Kundengesprächen und zum Entwerfen einer Antwort."
      caption: "Projekte, Chats und Kundengespräche in einem Arbeitsbereich."
    agents:
      label: "Der Tab Agenten eines Tale-Projekts zum Prüfen der Konfiguration eines Agenten."
      caption: "Jeder Projektagent hat seine eigene Laufzeitumgebung, sein Modell, seine Anweisungen und seine Ausstattung."
    chat:
      label: "Der Chat-Arbeitsbereich von Tale zum Schreiben von Prompts und zum Lesen von KI-Antworten."
      caption: "Schreibe einen Prompt, verfolge die Antwort und setze die Arbeit fort."
    projects:
      label: "Das Aufgabenboard eines Tale-Projekts zeigt Aufgaben, ihren Status und die verantwortliche Person."
      caption: "Behalte das gesamte Projekt im Blick, von vorgeschlagener Arbeit bis zur Prüfung und zum Abschluss."
    automations:
      label: "Ein Tale-Automatisierungslauf zeigt einen abgeschlossenen Workflow, die Ergebnisse seiner Schritte, die Version und den Laufstatus."
      caption: "Prüfe den Workflow und das Ergebnis jedes Schritts in einem echten Lauf."
    knowledge:
      label: "Die Tale-Wissensbibliothek zeigt gemeinsame Einträge zum Onboarding, zur Marke und zum Support."
      caption: "Bewahre Onboarding-, Marken- und Supportmaterial in einer gemeinsamen Bibliothek auf."
    governance:
      label: "Die Tale-Audit-Logs zeigen protokollierte Aktionen und wer sie ausgeführt hat."
      caption: "Prüfe, wer was geändert hat, kontrolliere die Log-Integrität und exportiere das Prüfprotokoll."
